import { http } from 'http';

export default {
  getMasterData: () => http.get('/masterdata'),

  cms: (partnerId, patternId) => {
    const locale = process.env.APP_LOCALE;
    const appId = process.env.APP_ID;
    return http.get(`/cms/${locale}/templates/edocs-contents/patterns/${patternId}`, {
      headers: {
        AppId: appId,
        PartnerId: partnerId
      }
    });
  },

  getActByGuid: transactionId => http.get(`/actas/devolucion/${transactionId}`),

  catalogByPartnerIdAndStep: (partnerId, stepId) =>
    http.get(`/catalog/front/${partnerId}/${stepId}`),

  getPartnerData: id => http.get(`/basics/${id}`),

  getPartnerDataByTransactionId: transactionId =>
    http.get(`/basics/actas/devolucion/${transactionId}`),

  getConcessions: (documentId, zipCode) =>
    http.get(`/actas/devolucion/concesiones/${documentId}/${zipCode}`)
};
